export const getCompanyRateCodeFromQueryParams = (
  queryParams: NodeJS.Dict<string | string[]>
) => {
  return queryParams.companyRateCode as string | undefined;
};
